export default __webpack_public_path__ + "static/media/flogo_RGB_HEX-72.7a8b4ebe.svg";